import { Input, Select } from 'antd';
import { css } from '@emotion/css';
import { useCallback } from 'react';

const { Option } = Select;

interface SearchInputProps {
  selectOptions: {
    value: string;
    label: string;
  }[];
  selectValue?: string;
  onSelectChange: (value: string) => void;
  onSearch: (value: string) => void;
  placeholder: string;
}

export const SearchInput = (props: SearchInputProps) => {
  const { selectOptions, selectValue, onSelectChange, onSearch, placeholder } = props;

  const handleSelectChange = useCallback(
    (value: string) => {
      onSelectChange(value);
    },
    [onSelectChange],
  );

  const selectBefore = (
    <Select
      className={antSelectCls}
      dropdownMatchSelectWidth={false}
      value={selectValue}
      onChange={handleSelectChange}
    >
      {selectOptions.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );

  return (
    <Input.Search
      className={searchCls}
      addonBefore={selectBefore}
      allowClear
      enterButton
      placeholder={placeholder}
      onSearch={onSearch}
    />
  );
};

const antSelectCls = css`
  .ant-select-selector {
    max-width: 140px;
  }
`;

const searchCls = css`
  .ant-input-group-addon {
    background-color: transparent;
    border-color: #d3d7e0 !important;
  }

  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border: 1px solid transparent;
    box-shadow: none;
  }
  .ant-input-group-addon .ant-select-focused .ant-select-selector,
  .ant-input-group-addon .ant-select-open .ant-select-selector {
    color: inherit;
  }

  .ant-input-group-addon:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  .ant-input-group-addon:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;

    .ant-btn-primary {
      background-color: #ffffff;
      border-color: #d3d7e0;
      color: #000000;
    }
  }

  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper-focused,
  .ant-input-affix-wrapper:focus {
    border-color: #d3d7e0;
    box-shadow: none;
  }
`;
